// extracted by mini-css-extract-plugin
export default {"curtain":"BackGroundVideo_curtain__5ieIP","video-background":"BackGroundVideo_video-background__dVLAy","video-foreground":"BackGroundVideo_video-foreground__nw7hY"};